let _open: (() => void) | null = null;
let _close: (() => void) | null = null;

export function registerMobileMenuControl(open: () => void, close: () => void): () => void {
    _open = open;
    _close = close;
    return () => {
        _open = null;
        _close = null;
    };
}

export function openMobileMenu(): void {
    _open?.();
}

export function closeMobileMenu(): void {
    _close?.();
}
